import script from "./VehicleConfirmDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleConfirmDialog.vue?vue&type=script&setup=true&lang=js"

import "./VehicleConfirmDialog.vue?vue&type=style&index=0&id=1e9ced8f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e9ced8f"]])

export default __exports__